import ApiHelpers from '@/data/dao/base/ApiHelpers';
import Building from '@/data/models/building';
import Meter from "@/data/models/meter";
import MeterIdentificationResponses from "@/data/models/meterModelResponse";
import MeterModelForm from "@/data/models/meter-model-form";

export default class BuildingsDao {
  static getAllByUserId(userId: string): Promise<Array<Building>> {
    return ApiHelpers.get<Array<Building>>(`/admin/building/${userId}/all`).then((data) => data.map(it => Building.map(it)));
  }

  static getById(id: string): Promise<Building> {
    return ApiHelpers.get<Building>(`/admin/building/${id}`).then((data) => Building.map(data));
  }

  static create(building: Partial<Building>): Promise<Building> {
    return ApiHelpers.post<Building>(`/admin/building/create`, building).then((data) => Building.map(data));
  }

  static update(building: Partial<Building>, id: string): Promise<Building> {
    return ApiHelpers.patch<Building>(`/building/update/${id}`, building).then((data) => Building.map(data));
  }

  static requestComputeIdentification(meterModelForm: Partial<MeterModelForm>): Promise<[]> {
    return ApiHelpers.post<[]>(`/admin/building/compute-identification/${meterModelForm.buildingId}`, meterModelForm);
  }

  static getIdentifications(id: string): Promise<{ meter: Meter, models: MeterIdentificationResponses[] }[]> {
    return ApiHelpers.get<{ meter: Meter, models: MeterIdentificationResponses[] }[]>(`/admin/building/identifications/${id}`);
  }

  static removeIdentifications(buildingId: string, meterId: string, itemToDelete: string): Promise<any> {
    return ApiHelpers.delete(`/admin/building/identification/${buildingId}/${meterId}/${itemToDelete}`);
  }
}
